import React, { useState } from "react";
import PropTypes from "prop-types";

import styles from "./chips.scss";
import classNames from "../../utils/classNames";
import Check20 from "../../icons/Check20";

export default function Chips(props) {
    const { options, defaultValue } = props;
    const [value, setValue] = useState(defaultValue);

    function optionClick(new_value) {
        if (new_value === value) return;
        
        setValue(new_value);
        if (typeof props.onChange === "function") {
            props.onChange(new_value);
        } 
    }

    const chips = options.map((option) => {
        const isActive = option.value === value;
        return <div
            className={classNames(styles.option, {
                [styles.active]: isActive
            })}
            key={option.value}
            onClick={() => optionClick(option.value)}>
                {isActive && <div className={styles.active_icon}><Check20 /></div>}
                <span>{option.label}</span>
        </div>;
    });

    return (
        <div className={styles.container}>
            {chips}
        </div>
    )
};

Chips.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
    })),
    defaultValue: PropTypes.string,
    /**
     * Triggers on value changes.
     * 
     * @returns {string} Active value.
     */
    onChange: PropTypes.func
};

